import type { ReactNode } from 'react';

import { cn } from '@/shared/cn';
import { ADMIN_BULK_ACTION_ROW } from '@/shared/ui-class';

export type AdminBulkActionRowProps = {
  left?: ReactNode;
  children?: ReactNode;
  className?: string;
};

export function AdminBulkActionRow({
  left,
  children,
  className,
}: AdminBulkActionRowProps) {
  return (
    <div className={cn(ADMIN_BULK_ACTION_ROW, className)}>
      <div className="min-w-0 text-sm text-muted">{left}</div>
      {children ? (
        <div className="flex flex-wrap items-center gap-2">{children}</div>
      ) : null}
    </div>
  );
}
